import { APP_VERSION } from './version'

export const USER_MANUAL_LABEL = 'Manual de usuario (eIFU)'
export const USER_MANUAL_URL = `https://retinar.com.ar/manual-${APP_VERSION}.pdf`
